module.exports = __webpack_public_path__ + "static/media/manualIcon.feb37790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/manualIcon.svg
// module id = 1131
// module chunks = 0